export interface RenewalPlanLike {
  value?: number | string | null;
  value_yearly?: number | string | null;
}

export interface CouponMetadataLike {
  code?: string | null;
  type: 'percentage' | 'flat' | string;
  month_discount?: number | string | null;
  year_discount?: number | string | null;
  month_cycles?: number | string | null;
  year_cycles?: number | string | null;
}

export interface ComputeRenewalPriceCentsInput {
  plan: RenewalPlanLike;
  paymentRecurrency: 'monthly' | 'yearly' | string;
  couponMetadata: CouponMetadataLike | null | undefined;
}

function calculateDiscountedPrice(
  originalValue: number,
  couponType: string,
  discountValue: number,
): number {
  const value = Number(originalValue) || 0;
  const discount = Number(discountValue) || 0;

  if (couponType === 'percentage') {
    const discountAmount = (value * discount) / 100;
    return Math.max(0, value - discountAmount);
  }

  if (couponType === 'flat') {
    return Math.max(0, value - discount);
  }

  return value;
}

function calculatePixRenewalPrice(
  plan: RenewalPlanLike,
  recurrency: string,
  couponMetadata: CouponMetadataLike | null | undefined,
): number {
  const isYearly = recurrency === 'yearly';
  const value = isYearly
    ? Number(plan.value_yearly ?? 0)
    : Number(plan.value ?? 0);

  if (!couponMetadata) {
    return value;
  }

  const cycles = isYearly ? couponMetadata.year_cycles : couponMetadata.month_cycles;
  const discount = isYearly ? couponMetadata.year_discount : couponMetadata.month_discount;

  if (Number(cycles) !== -1 && (!cycles || Number(cycles) <= 0)) {
    return value;
  }

  return calculateDiscountedPrice(value, couponMetadata.type, Number(discount ?? 0));
}

export function computeRenewalPriceCents({
  plan,
  paymentRecurrency,
  couponMetadata,
}: ComputeRenewalPriceCentsInput): number {
  const value = calculatePixRenewalPrice(plan, paymentRecurrency, couponMetadata);
  return Math.round(Number(value) * 100);
}
